import React from "react"
import { Box, Chip } from "@mui/material"


export default function acrissColumn() {
	return {
		name: "acriss", label: "Acriss",
		options: {
			sort: false,
			headerAlign: 'center',
			customBodyRowRenderLite: value => <Box sx={{ textAlign: 'center' }}>
				{[...(value ?? [])].sort((a, b) => a.localeCompare(b)).map((item, idx) => (
					<Chip key={idx} label={item} sx={{ m: 0.25 }} />
				))}
			</Box>,
		}
	}
}
